import IAddress from '@sunbit-dev/common/models/IAddress';
import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import CommonThunk from '../models/CommonThunk';
import sunbitApi from '../services/sunbitApi';
import URLS from '../constants/urls';
import ApplicationError from '@sunbit-dev/common/models/ApplicationError';
import ApplicationStatus from '@sunbit-dev/common/enums/cardApply/ApplicationStatus';
import { replace } from 'connected-react-router';

export enum ActionTypes {
  ShowPlasticAddressModal = 'ShowPlasticAddressModal',
  HidePlasticAddressModal = 'HidePlasticAddressModal',
  SettingAddress = 'SettingAddress',
}

export const showPlasticAddressModal = () => ({
  type: ActionTypes.ShowPlasticAddressModal,
  showPlasticAddressModal: true,
});

export const hidePlasticAddressModal = () => ({
  type: ActionTypes.HidePlasticAddressModal,
  showPlasticAddressModal: false,
});

const setAddressPending = () => ({
  type: ActionTypes.SettingAddress,
  status: ActionStatus.Pending,
});

const setAddressSuccess = () => ({
  type: ActionTypes.SettingAddress,
  status: ActionStatus.Success,
});

const setAddressFailure = (error: ApplicationError, payload: any) => ({
  type: ActionTypes.SettingAddress,
  status: ActionStatus.Failure,
  payload,
  error,
});

export const submitAddress = (address: IAddress, status?: ApplicationStatus): CommonThunk => {
  return async (dispatch) => {
    dispatch(setAddressPending());
    try {
      await sunbitApi.setPlasticAddress(address);
      dispatch(setAddressSuccess());
      let nextPageUrl;
      switch (status) {
        case ApplicationStatus.OFFER_ACCEPTED:
          nextPageUrl = URLS.applicationPaymentDetails;
          break;
        default:
          nextPageUrl = URLS.applicationApprovalTerms;
          break;
      }
      dispatch(replace(nextPageUrl));
    } catch (error: unknown) {
      dispatch(setAddressFailure(error as ApplicationError, { state: address.state }));
    }
  };
};

export type Actions = ReturnType<typeof showPlasticAddressModal>;
